export default __webpack_public_path__ + "static/media/step-two-1.11ddb0c1.svg";